import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RegistrationPricePlansIndexRoute extends Route {
  @service router;
  @service segment;

  activate() {
    this.segment.track('onboarding_price_plan_page_loaded');
  }

  redirect(registration, transition) {
    if (
      registration.legalFlow !== 'existing_company' &&
      // If the user is accessing directly and can access it, because previous condition matches, no need to redirect either
      transition?.to?.name !== 'registration.price-plans.offers'
    ) {
      // We should aim to sunset this one and have a single price page, as the modular pricing API makes this possible
      // For now it stays to handle partners api company-creation cases:
      // - price-plans.index => register-api
      // - price-plans.offers => partners-api
      this.router.replaceWith('registration.price-plans.offers');
    }
  }
}
